<ng-container *ngIf="customNodeAttribute">
  <ng-container [ngSwitch]="customNodeAttribute.properties.type">
    <ng-container *ngSwitchCase="customNodeAttributeTypesMap.TEXT">
      <q9-text-field
        [label]="customNodeAttribute.title | translate"
        [placeholder]="customNodeAttribute.placeholder | translate"
        [formControl]="control"></q9-text-field>
    </ng-container>

    <ng-container *ngSwitchCase="customNodeAttributeTypesMap.LONGTEXT">
      <q9-textarea-field
        [formControl]="control"
        [label]="customNodeAttribute.title | translate"
        [maxRows]="20"
        [minRows]="2"
        [placeholder]="customNodeAttribute.placeholder | translate">
        >
      </q9-textarea-field>
    </ng-container>

    <ng-container *ngSwitchCase="customNodeAttributeTypesMap.NUMBER">
      <q9-text-field
        type="number"
        [label]="customNodeAttribute.title | translate"
        [placeholder]="customNodeAttribute.placeholder"
        [formControl]="control"></q9-text-field>
    </ng-container>

    <ng-container *ngSwitchCase="customNodeAttributeTypesMap.DATETIME">
      <q9-datetime-picker
        [formControl]="control"
        [label]="customNodeAttribute.title | translate"
        [placeholder]="'YYYY/MM/DD' | translate"
        [readonly]="true"
        [type]="'date'"></q9-datetime-picker>
    </ng-container>

    <ng-container *ngSwitchCase="customNodeAttributeTypesMap.LIST">
      <div [ngClass]="{'q9-form-field-w-dependency': dependencyInstances.length && position !== 0}">
        <span class="circles-container" *ngIf="dependencyInstances.length">
          <ng-container *ngFor="let instance of dependencyInstances">
            <span
              class="circle"
              [ngStyle]="{'background-color': instance.color}"
              matTooltip="{{instance.hint}}"></span>
          </ng-container>
        </span>
        <q9-select
          [label]="customNodeAttribute.title | translate"
          [formControl]="control"
          [hint]="getHintMessage()"
          [placeholder]="customNodeAttribute.placeholder"
          [ngModel]="customNodeAttributeValue">
          <q9-option class="no-wrap" [value]="null">{{ 'None' | translate }}</q9-option>
          <q9-option
            *ngFor="let option of availableListOptions"
            [value]="option._id"
            class="no-wrap"
            [disabled]="option.hidden">
            {{ option.value }}
          </q9-option>
        </q9-select>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="customNodeAttributeTypesMap.MULTI_PICKLIST">
      <div
        [ngClass]="{'q9-form-field-w-dependency': dependencyInstances.length  && position !== 0}">
        <span class="circles-container" *ngIf="dependencyInstances.length">
          <ng-container *ngFor="let instance of dependencyInstances">
            <span
              class="circle"
              [ngStyle]="{'background-color': instance.color}"
              matTooltip="{{instance.hint}}"></span>
          </ng-container>
        </span>
        <q9-select
          [label]="customNodeAttribute.title | translate"
          [formControl]="control"
          [multiple]="true"
          [hint]="getHintMessage()"
          [placeholder]="customNodeAttribute.placeholder"
          [ngModel]="customNodeAttributeValue">
          <q9-option
            *ngFor="let option of availableListOptions"
            [value]="option._id"
            class="no-wrap">
            <div [class.unavailable-option]="option.hidden">{{ option.value }}</div>
          </q9-option>
        </q9-select>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
